import { Tabs } from 'expo-router';
import { ClipboardList, FileText, House, Menu, ShoppingBasket } from 'lucide-react-native';
import { colors, fonts } from '@hogar/shared';
import { useT } from '../../components/ui';
import { toRestock, useHouse } from '../../lib/house';

export default function TabLayout() {
  const { t } = useT();
  const { products } = useHouse();
  const restock = toRestock(products).length;
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: colors.textMuted,
        tabBarLabelStyle: { fontFamily: fonts.medium, fontSize: 11 },
        tabBarStyle: { backgroundColor: colors.white, borderTopColor: colors.divider, height: 64, paddingTop: 6 },
        sceneStyle: { backgroundColor: colors.background },
      }}
    >
      <Tabs.Screen name="index" options={{ title: t('tabHome'), tabBarIcon: ({ color }) => <House size={22} color={color} /> }} />
      <Tabs.Screen name="rutinas" options={{ title: t('tabRoutines'), tabBarIcon: ({ color }) => <ClipboardList size={22} color={color} /> }} />
      <Tabs.Screen
        name="productos"
        options={{
          title: t('tabProducts'),
          tabBarIcon: ({ color }) => <ShoppingBasket size={22} color={color} />,
          tabBarBadge: restock || undefined,
          tabBarBadgeStyle: { backgroundColor: colors.danger, fontSize: 11 },
        }}
      />
      <Tabs.Screen name="reportes" options={{ title: t('tabReports'), tabBarIcon: ({ color }) => <FileText size={22} color={color} /> }} />
      <Tabs.Screen name="mas" options={{ title: t('tabMore'), tabBarIcon: ({ color }) => <Menu size={22} color={color} /> }} />
    </Tabs>
  );
}
